// frontend/src/context/NotificationContext.js
import React, { createContext, useContext } from 'react';
import { notification } from 'antd'; // Import notification for useNotification hook

// Create the Notification Context
const NotificationContext = createContext(null);

// Custom hook to use the NotificationContext
export const useNotificationApi = () => {
  const context = useContext(NotificationContext);
  if (!context) {
    throw new Error('useNotificationApi must be used within a NotificationProvider');
  }
  return context;
};

// Notification Provider component
export const NotificationProvider = ({ children }) => {
  const [notificationApi, contextHolder] = notification.useNotification();

  // The value provided by the context will be the notificationApi instance
  const contextValue = notificationApi;

  return (
    <NotificationContext.Provider value={contextValue}>
      {/* The contextHolder must be rendered here, as it's tied to this specific hook instance */}
      {contextHolder}
      {children}
    </NotificationContext.Provider>
  );
};